export default __webpack_public_path__ + "static/media/party-emoji-left.f4c152de.png";